var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"shop"},[_c('div',{staticClass:"panel-title"},[_vm._v(" "+_vm._s(_vm.$t("storeManagement"))+" ")]),_c('shop-list',{attrs:{"type":"offline"}}),_c('shop-list',{attrs:{"type":"online"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }